import { Facade } from '@niknevis/vue-modules'
import { Obj } from '@/modules/shared/helpers'

export class ObjFacade extends Facade<Obj>() {
  static getFacadeAccessor() {
    return Obj
  }
}
